import { FC } from 'react';
import styled from 'styled-components';

import UserMenu from './UserMenu';

const StudioUserLoggedButtonsWrapper = styled.div`
  display: flex;
  > *:first-child {
    margin-right: 24px;
  }
`;

const StudioUserLoggedButtons: FC = () => (
  <StudioUserLoggedButtonsWrapper>
    <UserMenu />
  </StudioUserLoggedButtonsWrapper>
);

export default StudioUserLoggedButtons;
